import React, {useState} from 'react';
import {CkEditorInput} from '../Inputs/CkEditorInput';
import {useNotify} from "react-admin";
import {ENTRYPOINT} from '../../config/entrypoint';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@mui/material';
import {useInput} from 'react-admin';

const RewriteableEditor = ({
                               label,
                               source,
                               id,
                               rows = 3,
                           }) => {
    const [loading, setLoading] = useState(false);
    const {
        field: {value, onChange},
    } = useInput({source});

    const notify = useNotify();

    // modal state and data
    const [open, setOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const [createdContent, setCreatedContent] = useState('');
    const [systemPrompt, setSystemPrompt] = useState('You are a professional SEO copywriter specializing in German. Rewrite the following product description to improve SEO, maintain the original meaning, and format the output in clean SEO-optimized HTML. Use appropriate heading tags (like <h2> and <h3>), short paragraphs (<p>), and bullet points (<ul><li>) where relevant. Do not include <html>, <body>, <h1>, or <head> tags. Only return the HTML fragment.');


    const handleSubmitToChatGPT = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${ENTRYPOINT}/api/chatgpt`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('auth')}`,
                },
                body: JSON.stringify({ label, value: previewContent, id, source, systemPrompt }),
            });

            const data = await response.json();
            if (data?.content) {
                setCreatedContent(data.content);
            } else if (data?.message) {
                notify(data.message, { type: 'error' });
            }
            setLoading(false);
        } catch (error) {
            notify('Error processing request', { type: 'error' });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    const openPrompt = async () => {
        try {
            setPreviewContent(value);
            setOpen(true);
        } catch (error) {
            console.error('Error with sending request:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleApplyCreated = () => {
        onChange(createdContent);
        setOpen(false);
    };

    return (
        <div style={{marginBottom: '1rem'}}>
            <CkEditorInput
                multiline
                rows={rows}
                label={label}
                source={source}
                id={id}
                value={value}
            />
            <Button
                onClick={openPrompt}
                variant="outlined"
                size="small"
                disabled={loading}
                style={{marginTop: '0.5rem'}}
            >
                Rewrite & Generate SEO
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="lg"
                fullWidth
                aria-labelledby="rewrite-preview-dialog">
                <DialogTitle id="rewrite-preview-dialog">Rewrite content</DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="System prompt"
                        multiline
                        rows={4}
                        value={systemPrompt}
                        onChange={e => setSystemPrompt(e.target.value)}
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        style={{marginTop: '1rem'}}
                    />
                    <CkEditorInput
                        multiline
                        rows={rows}
                        label={label}
                        source={source}
                        id={id}
                        value={previewContent}
                        onChange={newVal => setPreviewContent(newVal)}
                        style={{marginTop: '1rem'}}
                    />
                    <Button
                        onClick={handleSubmitToChatGPT}
                        variant="outlined"
                        size="small"
                        disabled={loading}
                        style={{marginTop: '0.5rem'}}>{loading ? 'Loading response...' : 'Rewrite'}</Button>
                    {createdContent && (
                        <>
                            <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
                                <strong>Generated output:</strong>
                            </div>
                            <CkEditorInput
                                multiline
                                rows={rows}
                                label="Created content"
                                source={`${source}-created`}
                                id={`${id}-created`}
                                data={createdContent}
                                onChange={(event, editor) => setCreatedContent(editor.getData())}
                                style={{ marginTop: '1rem' }}
                            />
                            <Button
                                onClick={handleApplyCreated}
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                style={{ marginTop: '1rem' }}
                            >
                                {loading ? 'Loading...' : 'Apply'}
                            </Button>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default RewriteableEditor;
